import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Grid, Card, CardMedia, CardContent, Typography } from '@mui/material'
import DownloadButton from './DownloadButton'
import TicketButton from './TicketButton'

const EVENTS = [
  { flyer: require("../assets/FlyerVetDay26.jpg") },
  { flyer: require("../assets/FlyerSPChristmas26.jpeg") },
  { flyer: require("../assets/Flyer-full-calendar-26.jpg") }
]

export default function CalendarPage() {
  const location = useLocation()
  const [topHeight, setTopHeight] = useState(0)
  const [menuHeight, setMenuHeight] = useState(0)

  useEffect(() => {
    const top = document.getElementById("top-bar")?.getBoundingClientRect()?.height || 0
    const menu = document.getElementById("menu-bar")?.getBoundingClientRect()?.height || 0
    setTopHeight(top)
    setMenuHeight(menu)
  }, [])

  // Scroll to flyer if hash exists
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '')
      const element = document.getElementById(id)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }, 100)
      }
    }
  }, [location.hash])

  const minHeight = `calc(100vh - ${topHeight}px - ${menuHeight}px)`

  // Event flyer card defined inline
  function EventFlyerCard({ event, featured = false }) {
    return (
      <Card
        sx={{
          width: '100%',
          maxWidth: featured ? 500 : 400,
          mx: 'auto',
          boxShadow: 4,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CardMedia
          component="img"
          image={event.flyer}
          alt={event.title}
          sx={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
          }}
        />
        {(event.title || event.date) && (
          <CardContent sx={{ textAlign: 'center', p: 1 }}>
            {event.title && <Typography variant="h6">{event.title}</Typography>}
            {event.date && (
              <Typography variant="body2" color="text.secondary">
                {event.date}
              </Typography>
            )}
          </CardContent>
        )}
      </Card>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        minHeight,
        px: { xs: 2, md: 6 },
        py: 6,
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        <Grid
          item
          xs={12}
          id="flyer-0" // unique ID for hash scrolling
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          {/* <EventFlyerCard event={EVENTS[0]} featured /> */}
        </Grid>

        {EVENTS.slice(0).map((event, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            key={index + 1}
            id={`flyer-${index + 1}`} // unique ID for hash scrolling
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <EventFlyerCard event={event} />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <DownloadButton
          text="San Pedro Full Year Calendar Pdf"
          url={require("../assets/SanPedroCalendarCurrent.pdf")}
        />
      </Box>
    </Box>
  )
}